import CreatableCombobox from './CreatableCombobox';
import { Label } from './ui/label';

export const EquipmentSizeField = ({ item, catalog, onChange, testid, dark = false, disabled = false }) => {
  const groups = catalog.sizeGroupsFor(item.equipment_type, item.style, item.make, item.model);
  const missing = !item.equipment_type ? 'equipment type' : !item.style ? 'style' : !item.make ? 'manufacturer' : !item.model ? 'model' : '';
  return (
    <div className="min-w-0 space-y-1.5" data-testid={`${testid}-field`}>
      <Label className={dark ? 'text-slate-300' : ''}>Size</Label>
      <CreatableCombobox value={item.size || ''} options={groups.flatMap((g) => g.options)} optionGroups={groups}
        onChange={onChange} noun="size" disabled={disabled || (!!missing && !item.size)} placeholder={missing ? `Select ${missing} first` : 'Select or type a size'} testid={testid} dark={dark} />
    </div>
  );
};